// extracted by mini-css-extract-plugin
export default {"wrapper":"LibraryPage_wrapper__lEY6A","box":"LibraryPage_box__VKEpl","text":"LibraryPage_text__H-Gjp","img":"LibraryPage_img__tcqYI","btn":"LibraryPage_btn__Tc8Di"};